import React from "react";
import InstallPrompt from "./InstallPrompt";

/** App-wide PWA install prompts (Android card + iOS modal). */
export default function PwaInstallPrompts() {
  return <InstallPrompt />;
}
